import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-muted" }
const _hoisted_2 = { class: "pl-2" }

import FilterablePopover from "~/core-ui/vue/ui/FilterablePopover.vue";
import PopoverMenuItem from "~/core-ui/vue/ui/popover-menu/PopoverMenuItem.vue";
import PopoverMenu from "~/core-ui/vue/ui/popover-menu/PopoverMenu.vue";
import {computed, ref} from "vue";
import getCopilotsBySite from "~/operatorApplication/ts/service/copilot/getCopilotsBySite";
import {getCopilotAuthByClient} from "~/operatorApplication/ts/service/copilot/toggleCopilotSuggests";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {__} from "~/ts/library/Translate";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "CopilotPopover"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    site: {},
    client: {}
  }, {
    "modelValue": { type: Boolean, ...{
    default: false,
} },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["select"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let copilots = computed(() => getCopilotsBySite(props.site));

let model = _useModel<boolean>(__props, "modelValue");

let authToDisplay = computed(() => {
    let result = copilots.value;
    if (copilotFilter.value) {
        let filter = copilotFilter.value.toLowerCase();
        result = result.filter(result => result.descr.toLowerCase().includes(filter));
    }
    return result;
});

let copilotFilter = ref<string>(null);

let selectedAuth = computed(() => getCopilotAuthByClient(props.client, props.site));

async function selectAuth(auth?: OperatorApplicationApi.OperatorGetParamsIntegrationAuthOpenApiModel) {
    model.value = false;
    emits("select", auth);
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    visible: _unref(model),
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event)),
    trigger: "click",
    "popper-class": "p-0"
  }, {
    reference: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    default: _withCtx(() => [
      (_unref(model))
        ? (_openBlock(), _createBlock(FilterablePopover, {
            key: 0,
            modelValue: _unref(copilotFilter),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(copilotFilter) ? (copilotFilter).value = $event : copilotFilter = $event))
          }, {
            "after-input": _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  type: "danger",
                  plain: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (selectAuth(null)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(__)("Выкл")), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_my_tooltip, _unref(__)('Выключить подсказки')]
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(PopoverMenu, null, {
                default: _withCtx(() => [
                  _createVNode(PopoverMenuItem, { disabled: "" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(FontAwesomeIcon, {
                          icon: "check",
                          class: "icon"
                        }),
                        _createTextVNode(" " + _toDisplayString(_unref(__)("Выберите бота для подсказок")), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(authToDisplay), (auth) => {
                    return (_openBlock(), _createBlock(PopoverMenuItem, {
                      onClick: ($event: any) => (selectAuth(auth))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass({
                            selected: _unref(selectedAuth) === auth
                        })
                        }, [
                          _createVNode(FontAwesomeIcon, {
                            icon: "check",
                            class: "icon"
                          }),
                          _createTextVNode(" " + _toDisplayString(auth.descr), 1)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 256))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["visible"]))
}
}

})